import RootLayout from '@/routes/root/view/RootLayout.tsx'
import useSyncUser from '@/lib/hooks/useSyncUser.ts'
import useNavigateToDefaultPath from '@/routes/root/lib/hooks/useNavigateToDefaultPath.ts'
import useProjectStageData from '@/routes/root/lib/hooks/useProjectStageData.ts'
import useUpdateStageTabHref from '@/routes/root/lib/hooks/useUpdateStageTabHref.ts'
import useRecordVisitedPath from '@/lib/hooks/useRecordVisitedPath.ts'
import { useParams } from 'react-router-dom'
import { ProjectStageParamsT } from '@/routes/projectStages/routes.tsx'
import { useQueueAutoSync } from '@/lib/helpers/bgSync/useQueueAutoSync.ts'

export default function Root() {
  const { projectStageId } = useParams() as ProjectStageParamsT
  useSyncUser()

  // if projectStageId is found, loader will be executed in projectsRoot
  useProjectStageData({ path: `Root`, disabled: !!projectStageId })
  useNavigateToDefaultPath()
  useUpdateStageTabHref()
  useRecordVisitedPath()
  useQueueAutoSync()

  return <RootLayout />
}
